<template>
  <div style="overflow-y: scroll;max-height: 100%">
    <template v-if="dishInfo&&selectedTypeId">
      <div class="text-h6 px-4 mt-4">
        {{ canChange ? $t('CustomizeYourBase') : $t('basePot') }}
      </div>

      <div class="px-4">
        <div
          class="my-10 mx-8 "
          style="padding: 12%;
                 background: url('img/background/6.png') center / contain no-repeat"
        >
          <template v-if="maxFlavors===1">
            <div
              :style="selectedImage[0]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[0]+')'
                }:{
                  background:'rgba(255,255,255,0.15)'
                }"
              style="width: 100%;background: left / cover;border-radius: 100% 100% 100% 100%"
            >
              <v-responsive :aspect-ratio="1"></v-responsive>
            </div>
          </template>
          <template v-if="maxFlavors===2">
            <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));">
              <div
                :style="selectedImage[0]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[0]+')'
                }:{
                  background:'rgba(255,255,255,0.15)'
                }"
                style="width: 100%;background: left / cover;border-radius: 100% 0 0 100%/50%"
              >
                <v-responsive :aspect-ratio="0.5"></v-responsive>
              </div>
              <div
                :style="selectedImage[1]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[1]+')'
                }:{
                  background:'rgba(255,255,255,0.2)'
                }"
                style="width: 100%;background: right / cover;border-radius: 0 100% 100% 0/50%"
              >
                <v-responsive :aspect-ratio="0.5"></v-responsive>
              </div>
            </div>

          </template>
          <template v-if="maxFlavors===3">
            <div style="border-radius: 50%;width:100%;position: relative;overflow: hidden">
              <v-responsive :aspect-ratio="1">
                <div

                  style="width: 58%;height: 58%;position: absolute;left: 50%;top: 50%;
                    transform-origin: 0% 0%;transform: rotate(0deg) skewX( -30deg);overflow: hidden"
                >
                  <div
                    :style="selectedImage[2]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[2]+')'
                }:{
                  background:'rgba(255,255,255,0.1)'
                }"
                    style="transform:translate(-50%,-50%) skewX(30deg) ;width: 200%;height: 200%;background: bottom / cover"
                  >
                  </div>

                </div>
                <div
                  style="width: 58%;height: 58%;position: absolute;left: 50%;top: 50%;
                    transform-origin: 0% 0%;transform: rotate(120deg) skewX( -30deg);overflow: hidden"
                >
                  <div
                    :style="selectedImage[0]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[0]+')'
                }:{
                  background:'rgba(255,255,255,0.12)'
                }"
                    style="transform:translate(-50%,-50%) skewX(30deg)  rotate(-120deg);width: 200%;height: 200%;background: bottom / cover"
                  >
                  </div>
                </div>
                <div

                  style="width: 58%;height: 58%;position: absolute;left: 50%;top: 50%;
                    transform-origin: 0% 0%;transform: rotate(240deg) skewX( -30deg);overflow: hidden"
                >
                  <div
                    :style="selectedImage[1]?{
                  backgroundImage:'url('+GlobalConfig.resourceRoot+selectedImage[1]+')'
                }:{
                  background:'rgba(255,255,255,0.15)'
                }"
                    style="transform:translate(-50%,-50%) skewX(30deg) rotate(-240deg);width: 200%;height: 200%;background: bottom / cover"
                  >
                  </div>

                </div>
              </v-responsive>

            </div>

          </template>
        </div>
        <div
          :style="{gridTemplateColumns: 'repeat('+type.length+', 1fr)'}"
          class="my-4 px-4 overflow-hidden overflow-x-auto"
          style="display: grid;grid-auto-flow: column;grid-gap: 12px;"
        >
          <v-card
            v-for="t in type"
            :key="t.id" :color="selectedTypeId===t.id?'grey darken-3':''" :disabled="!canChange" class="pa-4"
            elevation="0"
            @click="selectedTypeId=t.id"
          >
            <div class="d-flex align-center justify-center text-body-2" style="height: 100%;white-space: nowrap">
              {{ t.name }}
            </div>
          </v-card>
        </div>

        <div class="text-body-2 mt-4">
          {{ $t('YouCanChoose') }} {{ selectedType.maxFlavor }}
          <template v-if="selectedType.maxFlavor < 2">{{ $t('Flavor') }}</template>
          <template v-else>{{ $t('Flavors') }}</template>
        </div>
      </div>

      <div
        class="mt-2 px-4"
        style="display:grid;grid-gap: 12px;grid-template-columns: repeat(2,minmax(0,1fr))"
      >
        <v-card
          v-for="f in flavors"
          :key="f.id"
          :color="selectedFlavors.includes(f.id)?'grey darken-3':''" :disabled="!canChange"
          class="d-flex align-center" @click="selectFlavor(f.id)"
        >

          <div class="pa-2">
            <v-img :height="36" :src="GlobalConfig.resourceRoot+f.image" :width="36" class="rounded-lg"/>
          </div>
          <div class="pa-2 overflow-hidden">
            <div class="text-body-2 text-truncate text-no-wrap ">
              {{ f.name }}
            </div>
            <div class="text-caption text--secondary">
              + {{ f.price | priceDisplay }}
            </div>
          </div>
        </v-card>
      </div>
      <div style="height: 96px"></div>
      <div
        class="d-flex grey darken-4 justify-center align-center pa-3"
        style="position: fixed;bottom: 64px;width: 100%"
      >
        <div class="flex-grow-1">
          <div class="d-block overflow-hidden" style="height: 100%">
            <div class="d-flex align-center">
              <div class="text-truncate text-body-1 font-weight-black">
                {{ selectedType.name }}
              </div>
              <v-spacer></v-spacer>
              <div class="text-body-1 text-no-wrap"></div>
            </div>
          </div>
          <div class="text-caption text--secondary">
            {{ selectedType.desc }}
          </div>
        </div>

        <v-card
          v-if="canChange"
          :color="!canNotOrder?'primary black--text':''"
          :disabled="canNotOrder"
          :loading="loading"
          class="pa-2 px-4 d-flex ml-2 justify-center align-center"
          @click="submitOrder"
        >
          <v-icon :color="!canNotOrder?'black':''" left>mdi-check</v-icon>
          <div class="font-weight-black">{{ totalPrice| priceDisplay }}</div>
        </v-card>
        <template v-else>
          <div class="font-weight-black">{{ totalPrice| priceDisplay }}</div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>

import i18n from "@/plugins/locales/i18n";
import {addHotpotDishToTable, getOrderedHotpotDish, hotpotDishInfo} from "@/dataLayer/repository/HotpotViewmodel";
import {meanBy, sumBy} from "lodash-es";
import {GlobalConfig} from "@/dataLayer/repository/GlobalSettingManager";


export default {
  name: "HotpotOpenTablePage",
  data: function () {
    return {
      selectedPersonCount: null,
      selectedTypeId: i18n.t('SingleFlavorKettle3'),
      dishInfo: null,
      selectedFlavors: [],
      loading: false,
      orderedDish: null,
    };
  },
  watch: {
    selectedTypeId() {
      this.selectedFlavors = []
    }
  },
  mounted() {
    this.loadInfo()
  },
  computed: {
    canChange() {
      return !this.orderedDish
    },
    GlobalConfig() {
      return GlobalConfig
    },
    flavors() {
      return this.selectedType?.select?.map(it => {
        return {
          id: it.value,
          name: it.text,
          image: it.image,
          price: it.price,
          priceInfo: it.priceInfo,
          groupId: this.selectedType.id
        }
      }) ?? []
    },
    type() {
      return this.dishInfo?.easyMod?.map(it => {
        return {
          name: it.name,
          desc: it.select.map(it => it.text).join(', '),
          maxFlavor: it.maxCount,
          price: meanBy(it.select, 'price') * it.maxCount,
          recommended: it.maxCount === '2',
          id: it.id,
          select: it.select
        }
      }) ?? []
    },
    maxFlavors() {
      return parseInt(this.selectedType.maxFlavor)
    },
    selectedImage() {
      return this.flavors.filter(it => this.selectedFlavors.includes(it.id)).map(it => it.image)
    },
    canNotOrder() {
      return this.selectedFlavors.length !== this.maxFlavors
    },
    selectedFlavorsValue() {
      return this.flavors.filter(it => this.selectedFlavors.includes(it.id))
    },
    selectedType() {
      return this.type.find(it => it.id === this.selectedTypeId)
    },
    totalPrice() {
      return sumBy(this.selectedFlavorsValue, 'price')
    },
  },
  methods: {
    async loadInfo() {
      this.dishInfo = await hotpotDishInfo()
      this.selectedTypeId = this.type[0].id
      const ordered = await getOrderedHotpotDish()
      console.log(ordered)
      if (ordered) {
        this.selectedTypeId = ordered.agId.split(',')[0]
        ordered.aId.split(',').forEach(id => this.selectFlavor(id))
      }
      this.orderedDish = ordered

    },
    async submitOrder() {
      this.loading = true
      const res = await addHotpotDishToTable(this.dishInfo, this.selectedFlavorsValue)
      this.loading = false
      this.$emit('close')
      console.log(res)
    },
    selectFlavor(id) {
      if (!this.canChange) {
        return
      }
      if (this.selectedFlavors.includes(id)) {
        this.selectedFlavors = this.selectedFlavors.filter(it => it !== id)
      } else {
        if (this.selectedFlavors.length >= this.maxFlavors) {
          this.selectedFlavors.shift()
        }
        this.selectedFlavors.push(id)
      }
      this.selectedFlavors = [...this.selectedFlavors]
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

</style>
